export default {
  title: 'My Rewards',
  menu: 'Rewards',
  label: {
    myRewards: 'My Rewards',
    myReferrals: 'My Referrals',
    redeemHistory: 'Redeem History',
    getRewards: 'Get Rewards',
    weChatQrCodeTip: 'Scan QR codes on WeChat and bind account',
    payByWeChatWallet: 'Pay by WeChat Wallet',
    rewards: 'Rewards'
  },
  message: {
    noReferrals: 'Uh oh! You have not earned any referral points yet. View the jobs list to find participating jobs and start referring today!',
    noRedeemHistory: 'Uh oh! You have not any redeem history yet. View the jobs list to find participating jobs and start referring today!',
    redeemInProcess: 'Redeeming...',
    redeemHasError: 'Unsuccessful redemption. Please try again later or contact customer service on 400-990-3308',
    redeemSuccess: 'Successful redemption',
    copyRedeemCodeOrClose: 'Copy and redeem from JD.com',
    copyRedeemCode: 'Copy and redeem from JD.com',
    copySuccess: 'Copied successfully',
    copyFail: 'Copy failure. Please try to long tap to copy again',
    copyWithCtrlC: 'Please press CTRL + C to copy'
  },
  rewardsUnit: {
    cash: 'Yuan',
    jdEPoints: 'JD.com e-card',
    points: 'points'
  },
  referralStep: {
    applied: 'Application Rewards',
    interviewed: 'Interview Rewards',
    onboard: 'Onboard Rewards',
    probation: 'Pass Probation Rewards'
  },
  goods: {
    JD_E_CARD: 'JD e-points'
  },
  btn: {
    myReferrals: 'My Referrals',
    redeemHistory: 'Redeem History',
    redeemPoints: 'Redeem {points}',
    viewJDECode: 'View JD.com e-card'
  },
  custom: {
    starbucks: {
      title: 'My Referral Rewards',
      listHead: 'Detail',
      stepName: {
        applied: 'Applied',
        interviewed: 'Interviewed',
        onboard: 'Onboarding',
        probation: 'Pass Probation'
      },
      listColumnName: {
        applicantName: 'Name',
        jobName: 'Job',
        stepName: 'Status',
        date: 'Date'
      },
      viewPolicyBtn: 'View Referral Reward Policy',
      referralRewardsPolicy: '星巴克推荐奖励政策'
    },
    elc: {
      tipMessage: '请联系人事部门了解具体奖励信息'
    }
  }
}
